import ApiService, { IRequestParameters } from '@/plugins/api-plugin/services/api.service'
import DataProcessingSchedulerJobDao from '@/interfaces/admin/DataProcessingSchedulerJob.dao'
import { PageNumberPagination } from '@/interfaces/common/PageNumberPagination'

export default class DataProcessingSchedulerJobsService extends ApiService {
    async getDataProcessingSchedulerJobs(
        params?: IRequestParameters,
    ): Promise<[DataProcessingSchedulerJobDao[], PageNumberPagination] | null> {
        return this.request<undefined, [DataProcessingSchedulerJobDao[], PageNumberPagination] | null>(
            'GET',
            '/data-processing-scheduler-jobs',
            params,
            undefined,
            undefined,
            'getDataProcessingSchedulerJobs',
        ).catch(() => null)
    }
}
